exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cursor-pointer[data-v-67a3389f]{cursor:pointer}.img-thumbnail[data-v-67a3389f]{border-radius:4px;-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s}.img-thumbnail[data-v-67a3389f]:hover{-webkit-transform:scale(1.05);transform:scale(1.05);-webkit-box-shadow:0 4px 12px rgba(0,0,0,.2);box-shadow:0 4px 12px rgba(0,0,0,.2)}.bg-black[data-v-67a3389f]{background-color:#000!important}", ""]);

// exports
